var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgError = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.334 32.075c0-26.98-22.364-29.25-28.107-29.383a92.896 92.896 0 0 0-2.212-.025h-.567c-5.885.05-27.781 2.07-27.781 29.241 0 27.205 22.096 29.334 27.99 29.417.3.008.609.008.918.008.617 0 1.235-.008 1.77-.016 5.6-.1 27.989-2.204 27.989-29.242zm-2.446 0c0 24.425-19.592 26.687-25.594 26.796-.35.011-.738.015-1.14.018l-.58.007-.876-.008c-2.563-.034-9.149-.518-14.942-4.166-7.062-4.458-10.643-12.12-10.643-22.814 0-10.676 3.54-18.323 10.535-22.722 5.743-3.614 12.279-4.048 14.825-4.073h.542c.735 0 1.495.008 2.154.025 2.563.066 9.14.6 14.967 4.257 7.137 4.474 10.752 12.104 10.752 22.68zm-26.896 9.733a1.22 1.22 0 0 1-1.219-1.218V15.263a1.22 1.22 0 0 1 1.219-1.219c.668 0 1.219.551 1.219 1.22V40.59a1.22 1.22 0 0 1-1.219 1.218zm1.92 5.026a1.911 1.911 0 1 0-3.823 0 1.911 1.911 0 0 0 3.823 0z",
    fill: "#FF374A"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgError, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/error.802309a7.svg";
export { ForwardRef as ReactComponent };